<!-- @format -->

@if (!!secondaryRatings.length) {
	<div
		class="hmf-mt-m hmf-px-s"
		[ngClass]="{ 'hmf-mt-lg-l ': isHighlight, 'hmf-mt-m-0': !isHighlight }">
		@for (
			secondaryRating of secondaryRatings;
			track $index.toString() + secondaryRating.label;
			let ratingIndex = $index
		) {
			<div
				class="category-rating-container"
				[ngClass]="{
					'hmf-display-flex hmf-flex-rows hmf-align-items-center rating':
						secondaryRating.type !== 'SLIDER',
					'hmf-mt-s': !!ratingIndex
				}">
				@if (!!secondaryRating.label) {
					@if (secondaryRating.type === 'SLIDER') {
						<ng-container>
							<label
								[for]="'category-rating' + ratingIndex"
								class="hmf-body-bold-m hmf-text-transform-capitalzize slider-label hmf-mb-xxxs"
								aria-label="Title Label"
								>{{ secondaryRating.label }}</label
							>

							<input
								[id]="'category-rating' + ratingIndex"
								class="category-rating-container-slider"
								type="range"
								[min]="secondaryRating.minValue"
								[max]="secondaryRating.maxValue"
								[value]="secondaryRating.value"
								disabled
								aria-label="slider" />

							<div class="hmf-display-flex hmf-justify-content-between hmf-mt-xxxs">
								<label
									[for]="'category-rating' + ratingIndex"
									class="hmf-text-transform-capitalize hmf-legal-xs min-label ellipsis hmf-text-align-left"
									aria-label="Min Label Value"
									>{{ secondaryRating.minLabel }}</label
								>
								<label
									[for]="'category-rating' + ratingIndex"
									class="hmf-text-transform-capitalize hmf-legal-xs min-label ellipsis hmf-text-align-center"
									aria-label="Middle Label Value"
									>{{ secondaryRating.middleLabel }}</label
								>
								<label
									[for]="'category-rating' + ratingIndex"
									class="hmf-text-transform-capitalize hmf-legal-xs max-label ellipsis hmf-text-align-end"
									aria-label="Max Label Value"
									>{{ secondaryRating.maxLabel }}</label
								>
							</div>
						</ng-container>
					} @else {
						<ng-container #categoryRatingContent>
							<label
								[for]="'category-rating' + ratingIndex"
								class="hmf-body-m hmf-text-transform-capitalize slider-text narrow-label"
								aria-label="Title Label"
								>{{ secondaryRating.label }}</label
							>

							<input
								[id]="'category-rating' + ratingIndex"
								class="category-rating-container-slider"
								type="range"
								[min]="secondaryRating.minValue"
								[max]="secondaryRating.maxValue"
								[value]="secondaryRating.value"
								disabled
								aria-label="slider" />

							<label
								[for]="'category-rating' + ratingIndex"
								class="hmf-legal-xs slider-text hmf-display-flex hmf-justify-content-flex-end"
								aria-label="Range Label Value">
								{{ secondaryRating.averageRating | number: '1.0-1' }} /
								{{ secondaryRating.valueRange }}
							</label>
						</ng-container>
					}
				}
			</div>
		}
	</div>
}
